import styled from 'styled-components/macro';
import { AccordionContainer } from '@yme/atoms/accordion';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorBlackTransparent50, colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { fontWeightMedium } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
export const NavigationButtonStyled = styled.div `
  padding: ${INDENT.xxxxs};
  cursor: pointer;
  &:hover {
    background-color: ${colorBlackTransparent50};
    border-radius: ${CORNER_RADIUS.circle};
  }
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
`;
export const LeftNavigationButtonStyled = styled(NavigationButtonStyled) `
  margin-right: ${INDENT.xxxs};
`;
export const DropdownLabelStyled = styled.span `
  display: flex;

  ${fontWeightMedium}
`;
export const DropdownOverlayStyled = styled.div `
  ${CustomScroll};
  padding-right: 2px; // to overwrite custom scroll default props
  border: none; // to overwrite custom scroll default props

  background-color: ${colorCoreWhite1000};
  position: absolute;
  z-index: ${Z_INDEX.level1};
  left: 0;
  right: 0;

  ${({ dropdownTitleRef }) => `
    top: calc(${dropdownTitleRef?.current?.clientHeight}px + ${INDENT.xxxs});
    // to overwrite custom scroll default props
    max-height: calc(100% - ${dropdownTitleRef?.current?.clientHeight}px - ${INDENT.xxxs}); 
    height: calc(100% - ${dropdownTitleRef?.current?.clientHeight}px - ${INDENT.xxxs});
  `};

  ${ADAPTIVE.maxWidth.tablet} {
    ${AccordionContainer} {
      border: 1px solid ${colorCoreGray500};
    }
  }
`;
